<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="teacherId!=null && teacherId!='' && teacherId!='new'">Секц мэдээлэл засах</span>
                      <span v-else>Бүтэц, секц нэмэх</span>
                      
                    </h1>
                  </div>
                  <form class="user">

                      <div class="form-group">
                        <label>Нэр: </label>
                        <input v-model.trim="teacher.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="нэр">
                      </div>
  
                    <div class="form-group">
                        <label>Тайлбар: </label>
                    
                        <textarea v-model.trim="teacher.description" class="form-control"></textarea>
                    </div>



                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../../firebaseConfig.js');
import { mapState } from 'vuex'
export default {
    name: "TeacherAdd",
    data() {
        return {
            teacher: {
                name: '',
 
            },
            performingRequest:false,
            cities:[],
            city:null,
            district:null,
            school:null,
            schools:[]
        };
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    methods: {
        save() {
            this.performingRequest = true
            if(this.teacher!=null && this.teacher.name!=''){
              if(this.teacher.id!=null && this.teacher.id!='' && this.teacher.id!='new'){
                this.teacher.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                this.teacher.modifiedAt=new Date();
                if(this.schoolId)
                  this.teacher.school=fb.db.collection("schools").doc(this.schoolId);
                
                fb.db.collection("schools/"+this.schoolId+"/sectors").doc(this.teacher.id).set(this.teacher)
                this.$router.back();
              }
              else{


                fb.db.collection("schools/"+this.schoolId+"/sectors").doc().get().then(doc=>{

        
                  this.teacher.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                  this.teacher.createdAt=new Date();

                   if(this.schoolId){
                    this.teacher.school=fb.db.collection("schools").doc(this.schoolId);
                    fb.db.collection("schools").doc(this.schoolId).update({numberOfSectors: fb.firestore.FieldValue.increment(1)});
                  }
          
                  doc.ref.set(this.teacher);
                  this.$router.back();

                });
                
              }
            }
        },
        setteacher(){
          this.teacher= {
              name: '',

          }
        },
       
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },

        async _getteacher(){
          if(this.schoolId){
            
          }
          if(this.teacherId!=null && this.teacherId!='' && this.teacherId!='new'){
            var teacherData=await fb.db.collection("schools/"+this.schoolId+"/sectors").doc(this.teacherId).get();
            let object=teacherData.data();
            object.id=teacherData.id
            this.teacher=object;
            
          }

          
        },

        
        
    }, 
    props: {
        teacherId: { 
            required: false,
        },
        schoolId:{
          required:true
        }
    },
    created() {
        this._getteacher();     
    },
  
};
</script>

